import React from 'react';
import TabularDataRows from './TabularDataRows';

export default function TabularDataSection(props) {
	if (props.tableData && props.section) {
		const currentSecion = props.tableData.sectionsData[props.section];
		const currentSecArr = Object.keys(currentSecion).map((key) => {
			return { key: key, value: currentSecion[key] };
		});
		const TableRows = currentSecArr.map((row, indx) => {
			return <TabularDataRows key={indx} row={row} compareItems={props.compareItems} />;
		});

		return (
			<React.Fragment>
				<header id="features" className="section-heading-wrapper">
					<p className="section-heading avenir-bold text-black">{props.section}</p>
				</header>
				<div className="comparison-feature__wrapper">{TableRows}</div>
			</React.Fragment>
		);
	} else {
		console.error('%c There is a problem with the table data, please check source! ', 'background: orange; color: black');
		return null;
	}
}
